export function parseKorrekturDelta(text: string): number | null {
  if (!/^\s*[+\-−]?\d+\s*$/.test(text)) return null
  const delta = Number(text.trim().replace('−', '-'))
  return Number.isSafeInteger(delta) && delta !== 0 ? delta : null
}

export type KorrekturAuftrag = {
  merchantSku: string
  delta: number
  qtyErwartet: number
  idempotencyKey: string
  reason: string
}
